import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, FormControlLabel, IconButton, Radio, RadioGroup, Stack, Typography } from "@mui/material";

interface Props {
  onCancel: () => void;
  onSubmit: (value: string) => void;
}

export const OverwriteSettings: React.FC<Props> = ({ onCancel, onSubmit }) => {
  const [value, setValue] = useState("all");

  return (
    <Stack
      sx={{
        outline: "none",
        width: 682,
        bgcolor: "white",
        p: "32px",
        gap: "20px",
        boxShadow:
          "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
        borderRadius: "8px"
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #DBE8F5"
        }}
      >
        <Typography sx={{ fontSize: 18, fontWeight: 400, color: "#071F35" }}>Parameters conflict</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack sx={{ gap: "10px" }}>
        <Typography sx={{ color: "#071F35", fontSize: 14, fontWeight: 400, lineHeight: "16px" }}>
          You are changing the parameters of the category while some of the sectors are already customized. To continue,
          please select one of the actions below:
        </Typography>

        <RadioGroup
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <FormControlLabel
            sx={{ margin: 0 }}
            value="all"
            control={<Radio sx={{ color: "#92A7BC" }} />}
            label="Apply for all sectors in the category"
          />
          <FormControlLabel
            sx={{ margin: 0 }}
            value="default_only"
            control={<Radio sx={{ color: "#92A7BC" }} />}
            label="Apply for all sectors accept already customized"
          />
        </RadioGroup>
      </Stack>
      <Stack sx={{ flexDirection: "row", gap: "8px", justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => onSubmit(value)}>
          Apply
        </Button>
      </Stack>
    </Stack>
  );
};
